// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"4f3cf9443eb199bc","6831":"5d9edd67bfd41787","8503":"0016113fe25f1179","9683":"58e9718d685ed23e"}[chunkId] + ".js";
};